// extracted by mini-css-extract-plugin
export var active = "_1y-7";
export var backButton = "_1y-6";
export var clone = "_1y-c";
export var collapseBar = "_1y-g";
export var collapseMode = "_1y-i";
export var dragHandle = "_1y-a";
export var dropdownIcon = "_1y-e";
export var hidden = "_1y-o";
export var iconContainer = "_1y-l";
export var iconSwapper = "_1y-n";
export var navItem = "_1y-4";
export var navItemIcon = "_1y-d";
export var navProfile = "_1y-5";
export var notificationDot = "_1y-m";
export var optionsContainer = "_1y-f";
export var primaryNav = "_1y-0";
export var primaryTab = "_1y-j";
export var secondaryNav = "_1y-1";
export var selected = "_1y-k";
export var settingsNav = "_1y-2";
export var settingsNavItems = "_1y-3";
export var show = "_1y-b";
export var sideNav = "_1y-h";
export var teamItem = "_1y-8";
export var userProfileItem = "_1y-9";